<template>
  <v-content>
    <v-container fluid>

      <v-card :elevation=1 outlined>

        <v-chip-group>
          <v-spacer/>
          <v-card-title>Генерация таблиц для конечного поля (GF)</v-card-title>
          <div id="v-model-select" class="modelselect">Предустановка: 
            <select v-model="preset" @change="onChangePreset">
              <option disabled value="">Выберите</option>
              <option>{{state.gf_2_2}}</option>
              <option>{{state.gf_2_3}}</option>
              <option>{{state.gf_3_1}}</option>
              <option>{{state.gf_4_1}}</option>
              <option>{{state.gf_5_1}}</option>
              <option>{{state.gf_6_1}}</option>
              <option>{{state.gf_7_1}}</option>
              <option>{{state.gf_2_2_bin}}</option>
              <option>{{state.gf_2_3_bin}}</option>
              <option>{{state.gf_2_4_bin}}</option>
              <option>{{state.gf_2_8_bin}}</option>
              <option>{{state.gf_5_1_bin}}</option>
              <option>{{state.gf_7_1_bin}}</option>
              <option>{{state.gf_8_1_bin}}</option>              
              <option>{{state.gf_3_2_k}}</option>
              <option>{{state.gf_3_3_k}}</option>
              <option>{{state.gf_5_2_k}}</option>
            </select>
          </div>  
          <v-spacer/> 
        </v-chip-group>
  
        <v-card-item>

          <v-chip-group>
            <v-text-field
              label="Порядок конечного поля - q"
              v-model="state.qgf"
              placeholder="2^1" 
              hint="GF(q)"
              :error-messages="v$.qgf.$errors.map(e => e.$message)"
              @blur="v$.qgf.$touch"
              @update:focused="checkDegree"
            ></v-text-field>
            &nbsp;&nbsp;&nbsp;
            <v-text-field
              label="Множество элементов GF {0, 1, ...}"
              v-model="state.argf"
              placeholder="0,1" 
              hint="0,1,x,x+1,x^2,x^2+1,x^2+x,x^2+x+1,..."
              :error-messages="v$.argf.$errors.map(e => e.$message)"
              @blur="v$.argf.$touch"
            ></v-text-field>
            &nbsp;&nbsp;&nbsp;
            <v-text-field
              label="Порождающий полином - g"
              v-model="state.ggf"
              placeholder="x^2+x+1" 
              hint="x^2+x+1"
              @update:focused="checkDegree"
            ></v-text-field>
          </v-chip-group>

          <v-chip-group>
            <v-spacer/>
              <div class="modelselect">
                <input type="checkbox" id="summ" value={{state.stSumm}} v-model="checkedSumm" />
                <label for="summ">{{state.stSumm}}</label>
                &nbsp;&nbsp;
                <input type="checkbox" id="mult" value={{state.stMult}} v-model="checkedMult" />
                <label for="mult">{{state.stMult}}</label>
                &nbsp;&nbsp;
                <input type="checkbox" id="deg" value={{state.stDegree}} v-model="checkedDegree" />
                <label for="deg">{{state.stDegree}}</label>
                &nbsp;&nbsp;
                <input type="checkbox" id="report" value={{state.stReport}} v-model="checkedReport" />
                <label for="report">{{state.stReport}}</label>                  
              </div>
            <v-spacer/>
              <v-btn @click="generatevalid">Сгенерировать таблицы</v-btn> 
            <v-spacer/>
            <v-btn @click="saveToPDF">-> PDF</v-btn>
          </v-chip-group>

        </v-card-item>

      </v-card>

      <div id="scroll-container">
        <div id="large-container">
          <div id="container"></div>
        </div>
      </div>

    </v-container>
  </v-content>

  <v-dialog
    v-model="dialog"
    width="auto"
  >
    <v-card>
      <v-card-title>{{ dialog_title }}</v-card-title>
      <v-card-text>{{ dialog_text }}</v-card-text>
      <v-card-actions>
        <v-btn block @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>

  .modelselect {
    font-family: sans-serif;
    border: 1px solid #eee;
    border-radius: 2px;
    padding: 10px;
    user-select: none;
    overflow-x: auto;
  }

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #f0f0f0;
    background: #fcfcfc;
    height: 100%;
    overflow: auto;
  }

  #large-container {
    width: 3000px;
    height: 3000px;
    overflow: hidden;
  }

  #scroll-container {
    width: calc(100% - 22px);
    height: calc(100vh - 22px);
    overflow: auto;
    margin: 10px;
    border: 1px solid grey;
  }  

</style>

<script>
//#region import
import { reactive } from 'vue' 
import { mapGetters } from "vuex"; 
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import Konva from 'konva';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { 
  addLeadingZero,
  bikToPolinom,
  //binToPolinom,
  //calcdeg,
  //calculate,
  checkBik,
  collectGroups,
  defineDegree, 
  //expandbracketsum,
  expandbracketsmulNoReduce,
  found,
  //getIndex,
  isArraysEqual,
  maxLengthStr,
  multiplication,
  //multel,
  //noContainSymbolS,
  //numberMultPolinom,
  polinomToDec,
  //polinomToBin,
  //polinomToBinSimple,
  polinomKtoBin,
  polinomKtoBinSimple,
  reduceArrDoublK,
  //reduceByCharacteristic,
  reduceElArrK,
  //removeLeadingZeroArr,
  //removeLeadingZeroBin,
  //removeLeadingZeroStr,
  summation,
  spreadArrToOnePlusX,
  //transPolinomK,
  //xoro,
  xori, 
  //xoro
} from '../utils/common.js';

var width = window.innerWidth;
var height = window.innerHeight;
var PADDING = 500;
var layer = '';
//#endregion import

export default {
data() {
  return {
    configKonva: {
      width: width,
      height: height
    },
    preset: this.state.gf_2_2, //  gf_2_2_bin  gf_3_2_k  gf_3_3_k  gf_3_1  gf_7_1_bin  
    checkedSumm: true,
    checkedMult: true,
    checkedDegree: false,
    checkedReport: false,
    dialog: false,
    arrDecodSum: [],
    arrDecodMult: [],
    cursor: " \u2192 ",
    err: '?', // устанавливать один символ
    lengthSumDecoding: 0,
    shifttablex: 0,
    deltashifttablex: 0,
  };
},

mounted() {
//#region Konva
  var stage = new Konva.Stage({
    container: 'container',
    width: window.innerWidth + PADDING * 2,
    height: window.innerHeight + PADDING * 2,
    draggable: true,
  });

  layer = new Konva.Layer();
  stage.add(layer);

  var scrollContainer = document.getElementById('scroll-container');

  function repositionStage() {
    var dx = scrollContainer.scrollLeft - PADDING;
    var dy = scrollContainer.scrollTop - PADDING;
    stage.container().style.transform =
      'translate(' + dx + 'px, ' + dy + 'px)';
    stage.x(-dx);
    stage.y(-dy);
  }

  scrollContainer.addEventListener('scroll', repositionStage);
  repositionStage();
//#endregion Konva

  if (this.gen != null) {
    this.state.qgf = this.gen.q;
    this.state.argf = this.gen.a.join(',');
    this.state.ggf = this.gen.g;
    this.preset = '';
  } else {
    this.onChangePreset();
  }
  //console.log('props.name->',  this.props);
},

methods: {

  disassPolinomDegreeToBin(s, ch){//
    // разбор: 'x^2', '(x+1)^2', '(x+1)^3' -> bin
    if(!s.includes('(')) {
      return polinomKtoBinSimple(s);
    } else {
      //найти степень
      const d = defineDegree(s);
      //найти то что между скобками
      const skPos = s.indexOf(')');
      let p = s.substring(1, skPos);

      let np;
      for(let i=2; i<=d; i++){
        if(i==2) np = p;
        np = expandbracketsmulNoReduce(np, p)
      }

      let arr = spreadArrToOnePlusX(np.split());// разобрать полином на мелочь: 1 и x
      arr = reduceArrDoublK(arr, ch);// удалить дубли по 1 и x количеством ch
      arr = collectGroups(arr, ch); // собрать в группу

      const rb = polinomKtoBin(arr.join('+'));

      return rb;
    }
  },

  defineMode(arrbase){ // Определить режим
    if (found('x', arrbase)) {
      this.state.mode = 0; // Полиномиальный
    } else if (arrbase[0].length > 1 && arrbase[0].includes('00')) { 
      this.state.mode = 2; // чисто Двоичный (bin)
    } else {
      this.state.mode = 1; // Числовой
    }
  },

  gentable(arrbase) {
    let p=1, n=1, k=1;
    if(this.state.qgf.includes('^')) {
      const arqgf= this.state.qgf.split('^');
      p = Number(arqgf[0]); 
      n = Number(arqgf[1]);
      k = Math.pow(p, n);
    } else {
      k = p = Number(this.state.qgf);
    }

    // На основе argf определить базовое множество элементов
    //const arrbase = this.state.argf.split(',');

    // количество элементов должно быть равным с количеством по полю argf
    if (k != arrbase.length) {
      this.dialog_title = "Ошибка";
      this.dialog_text = "Количество элементов множества не совпадает с q";
      this.dialog = true;
    }

    // Инициировать массивы для расшифровки, сначала очистить массивы
    this.arrDecodSum.length=0;
    this.arrDecodMult.length=0;
    this.initFillArrDecodSum(arrbase);
    this.initFillArrDecodMult(arrbase);

    // перевести порождающий полином в бинарный вид
    const g = polinomKtoBin(this.state.ggf);

    // Найти самый широкий элемент массива и определить в нем количество знаков
    this.maxlength = arrbase[arrbase.length - 1].length;
    if (this.maxlength < 3) this.maxlength = 2.5;
    
    const deltax = this.maxlength * 15; 
    const deltay = 32;

    this.renderParam(g);

    const errsum = this.renderSum(arrbase, deltax, deltay, k+1, g, p);
    const errmult = this.renderMult(arrbase, deltax, deltay, k+1, g, p);
    const prim = this.renderDegree(arrbase, p, deltax, deltay, g);

    if(this.checkedReport) {// Отчет показать под параметрами
      const errsumtext = (errsum==0) ? ('В суммировании нет ошибок') : ('Ошибок в суммировании: ' + errsum);
      const errmulttext = (errmult==0) ? ('В умножении нет ошибок') : ('Ошибок в умножении: ' + errmult);
      const primtext = (prim==0) ? ('Примитивный элемент не определен') : ('Примитивный элемент: ' + prim);
      const arr = 'Множество: [' + arrbase.join(',') + ']';
      const report = errsumtext + '; ' + errmulttext + '; '+ primtext+ '; ' + arr + '; ';
      layer.add(this.addText(10, 40, report, 20));
    }

  },

  renderDegree(arrbase, ch, deltax, deltay, g) {
    let line=1, fill='black', arr=[], ww=[]; //

    if (this.state.mode==0) { //Полиномиальный
      for (let i = 0; i < arrbase.length; i++) {
        arr.push(polinomToDec(arrbase[i]).toString()); //полином в десятичную систему
      }
      arrbase = []; // очистить массив
      arrbase = [...arr];
      arr = reduceElArrK('0', arr, 1);
    } else if (this.state.mode==1) { //Числовой
      arr = reduceElArrK('0', arrbase, 1);
    } else if (this.state.mode==2) { //Двоичный
      let char = 2;
      if(checkBik(g)) char = Number(ch);
      for (let i = 0; i < arrbase.length; i++) {
        arr.push(parseInt(arrbase[i], char).toString()); //в 10-ю систему 
      }
      arrbase = []; // очистить массив
      arrbase = [...arr];
      arr = reduceElArrK('0', arr, 1);
    }
   
    const n=arrbase.length;

    //заполнить нулями
    let ar = new Array(n);
    for (let i = 0; i < ar.length; i++) {
      ar[i] = new Array(n);
      for (let j = 0; j < n; j++) {
        ar[i][j] = 0;
      }
    }

    let prim = 0; // примитивный элемент

    for (let y = 0; y < n; y++) {
      let neutar = [], w=[];
      for (let x = 0; x < n; x++) {
        if (y>0 && x>0) {
          const yy = arr[y-1];
          const xx = arr[x-1];
          let ardeg=[];
          if (this.state.mode==0) {
            ardeg = this.calcDegMode0(yy, xx, arrbase, ch, g);
          } else if (this.state.mode==1) {
            ardeg = this.calcDegMode1(yy, xx, arrbase, ch);
          } else if (this.state.mode==2) {
            ardeg = this.calcDegMode2(yy, xx, arrbase, ch, g);
          }
          w.push(yy + '^'+ xx +'='+ ardeg[1]);
          ar[x][y] = ardeg[0];
          neutar.push(ardeg[0].toString());
        } else {
          ar[x][0] = arr[x-1];
        }
        if (y==0) {
          ar[0][x] = arr[x-1];
        }
      }
      if(neutar.length)
        if (isArraysEqual(arr.slice(0), neutar.slice(0)) && prim == 0){
          prim = ar[0][y];
          ww = [...w];
          break;
        }
    }
  
    ar[0][0] = '^';

    // теперь покажем если стоит флаг
    if(this.checkedDegree) {

      if (this.checkedSumm && this.checkedMult) {
        this.shifttablex = this.shifttablex + this.deltashifttablex*3 + (this.maxlength * n * this.deltashifttablex);
      } else if (this.checkedSumm || this.checkedMult) {
        this.shifttablex = this.deltashifttablex*2 + (this.maxlength * n * this.deltashifttablex);
      }

      let primview = false;

      ar.forEach((subjects) => {
        let num = 1;
        subjects.forEach((data) => {
          //console.log('num:', num);
          if (data==prim && !primview && prim != 0) { // prim зеленым 1 раз
            this.draw(line, num, data, deltax, deltay, 'green', 24);
            primview = true;
          } else {
            if(num < (Number(prim)+2)) {
              this.draw(line, num, data, deltax, deltay, fill, 20);
            } 
          }
          num++;
        });
        line++;
      });

      this.renderLine(this.shifttablex, deltax, deltay, (Number(prim)+1)); //mvv

      let y = (deltay*(n-(n-prim)+1))+75; // сдвиг для расшифровки

      let shifttablex = this.shifttablex+50;

/*       if(n>6) { //учесть если n>6(или <7) то учесть длину строки расшифровки
        const maxLength=maxLengthStr(this.arrDecodMult)*12;
        shifttablex = (this.shifttablex < maxLength) ? maxLength : this.shifttablex;
      } */

      //layer.add(this.addText(shifttablex, y, "Таблица cтепеней", 24));//24-размерШрифта

      let text = (prim==0) ? ("Примитивный элемент не определен") : ("Примитивный элемент определен: " + prim); 
      layer.add(this.addText(shifttablex, y, text, 20));

      //y = y+deltay;
      for (let i = 0; i < ww.length; i++){
        y+=deltay;
        layer.add(this.addText(shifttablex+30, y, ww[i], 20));
      }
    }

    return prim;
  },

  calcDegMode2(a, n, arrbase, ch, g){ // рассчитать a^n
    if(g>0) {
      return this.calcDegMode0(a, n, arrbase, ch, g);
    } else {
      let r = 1, w='';
      for (let i = 1; i <= n; i++) {
        r *= a;
      }
      if (!found(r.toString(), arrbase)) {
        const rr = r;
        r = r % ch;
        w = rr + " mod " + ch + this.cursor;
        if (!found(r.toString(), arrbase)) {
          r = this.err;
        }
      }
      return [r,w+r];
    }
  },

  calcDegMode1(a, n, arrbase, ch){ // рассчитать a^n
    //console.log('a, n:', a, n);
    let r = 1, w='';
    for (let i = 1; i <= n; i++) {
      r *= a;
    }
    if (!found(r.toString(), arrbase)) {

      //if(a==2) {
      const rr = r;
      r = r % ch;
      w = rr + " mod " + ch + this.cursor;
      if (!found(r.toString(), arrbase)) {
        r = this.err;
      }

      //}//

    }
    //console.log('r:', r);
    return [r,w+r];
  },

  calcDegMode0(a, n, arrbase, ch, g){ //  рассчитать a^n
    //console.log('a, n:', a, n);
    let r = 1, w='';

    //if(a > 7 && n > 7) return [this.err,this.err];
    //if(a == 8 && n == 8) return [this.err,this.err];

    //if(a == 2 && n == 4) {

    for (let i = 1; i <= n; i++) {
      r *= a;
    }
    if (!found(r, arrbase)) {
      //console.log('a, n:', a, n);
      // если нет в базе, значит в полиноме x^2 = 100 xoro 111 = 11 = x+1 = 3 есть в базе
      const b = Number(a).toString(ch); //.toString(2) 
      //console.log('b:', b); 
      const p = bikToPolinom(b, ch);
      //console.log('p:', p);
      // p возвести в n
      const pn =  (p.includes('+') || p.includes('^')) ? '('+p+')^'+n : p+'^'+n;
      //console.log('pn:', pn);
      const bin = this.disassPolinomDegreeToBin(pn, ch);
      //console.log('pn:', pn, ' -> ', bin);
      const xor = xori(bin.toString(), g.toString(), Number(ch));
      //console.log('xor:', xor);
      r = parseInt(xor, Number(ch)); //2 
      //console.log('r:', r);
      //console.log('pn:', pn, ' -> ', bin, ' -> ', xor, ' -> ', r);
      w=pn+this.cursor+bin+' xori '+ g + ' = '+ xor+this.cursor;
      if (!found(r.toString(), arrbase)) {
        r = this.err;
      }     
    }
    //console.log('r:', r);

    //}//
    
    return [r,w+r];
  },

//#region

  renderLine(shifttablex, deltax, deltay, n){
    const dy1 = ((deltay)-(deltay/(deltay/5))+50);
    const dy2 = ((deltay*n)-(deltay*n/(deltay*n/5))+70); 
    layer.add(this.addLine(deltax+shifttablex+7, dy1, deltax+shifttablex+7, dy2)); 
    const dx1 = deltax/(deltax/4)+shifttablex+5;
    const dx2 = deltax*n+shifttablex+5;
    layer.add(this.addLine(dx1, dy1+23, dx2, dy1+23)); 
  },

  renderMult(arrbase, deltax, deltay, n, g, ch){ 
    let errorline_mult = [], arr_mult = new Array(n);

    for (let i = 0; i < arr_mult.length; i++) { 
      let arr_line_mult = []; //сюда записываются значения элементов по столбцам
      arr_mult[i] = new Array(n);
      for (let j = 0; j < n; j++) {
        //Заполнить горизонталь
        if (j>0 && i>0) {
          //console.log('i:', i);
          let mult = this.mult(arrbase, arrbase[i-1], arrbase[j-1], g, ch);
          if (i != 1 ) { // избавиться от 0
            arr_line_mult[j-1] = mult; //вести учет введенных элементов строки
          }
          arr_line_mult[arrbase.length] = arrbase[i-1]; //записать номер строки
          arr_mult[i][j] = mult;

        } else {
          arr_mult[i][j] = arrbase[i-1];
        }
        //Заполнить вертикаль
        if (j==0) {
          arr_mult[0][i] = arrbase[i-1]; 
        }
      }
      // Поймать неправильный столбец в умножении, с дублями элементов
      const duplicates_mult = arr_line_mult.filter((e, i, a) => 
        (a.indexOf(e) !== i) && (i !== arr_line_mult.length - 1));
      if (duplicates_mult.length > 0) {
        errorline_mult.push(arr_line_mult[arr_line_mult.length-1]);
      }
    }
    arr_mult[0][0] = '*';

    if(this.checkedMult) {
      if (this.checkedSumm) this.shifttablex = this.maxlength * n * this.deltashifttablex;

      this.renderLine(this.shifttablex, deltax, deltay, n); //mvv

      let line = 1, fill = 'black';
      arr_mult.forEach((subjects) => {
        let num = 1;
        const filt = subjects.filter((e, i, a) => (a.indexOf(e) == 0) 
          && (found(e, errorline_mult)));      
        if (filt.length > 0) {
          fill = 'red';
          //this.showError('?');
        }
        let k = n;
        subjects.forEach((data) => {
          this.draw(line, num, data, deltax, deltay, fill, 20);
          num++;
          k--;
        });
        if (k==0) fill = 'black';
        line++;
      });

      this.renderArrDecodMult(n, deltay);
    }

    return errorline_mult.length;
  },

  mult(arrbase, i, j, g, ch){
    const ar = multiplication(arrbase, i, j, g, ch, this.state.mode);
    //console.log('ar', ar[1]);

    // Проверить операнды ab на вхождение в arrDecodMult
    const ab = '('+i+') * ('+j+')' + this.cursor;    
    const l = this.arrDecodMult.indexOf(ab); 
    if (l >= 0) { // Если найден, дописать результат в найденную строку
      this.arrDecodMult[l] = ab+ar[1];
    }

    return ar[0]; 
  },

  renderArrDecodMult(n, deltay) {
    let y=0, shifttablex=0;
    // учесть показ суммирования по lengthSumDecoding 
    if (this.lengthSumDecoding == 0) {
      y = (deltay*n)+100;
    } else {
      y = (deltay*n)+(deltay*this.lengthSumDecoding)+150;
    }

    if(n<7){ // для маленького количества (n до 6) расшифровку умножения вниз
      shifttablex = 20;
    } else { 
      y = (deltay*n)+100;
      if (this.checkedSumm) {
        const maxLength=maxLengthStr(this.arrDecodSum)*11;// поймать макс. длину строки расшифровки
        shifttablex = (this.shifttablex < maxLength) ? maxLength : this.shifttablex; 
      } else {
        shifttablex = 20;
      }

    }
   
    layer.add(this.addText(shifttablex, y, "Умножение:", 24)); //24-размер шрифта

    for (let i = 0; i< this.arrDecodMult.length; i++) {
      if (this.arrDecodMult[i][this.arrDecodMult[i].length-1] == this.err) {
        layer.add(this.addText(shifttablex, (y+deltay)+(i*deltay), this.arrDecodMult[i].slice(0, -1), 20, 'Arial', 'red'));
      } else {
        layer.add(this.addText(shifttablex, (y+deltay)+(i*deltay), 
          this.arrDecodMult[i], 20, 'Arial'));
      }
    }
  },

  summ(arrbase, i, j, g, ch){
    const ar = summation(arrbase, i, j, g, ch, this.state.mode);
    //console.log('ar[1]:', ar[1]);

   // Проверить операнды 'ab' на вхождение в arrDecodSum для расшифровки
    const ab = "("+i+") + ("+j+")" + this.cursor;        
    const l = this.arrDecodSum.indexOf(ab); 
    if (l >= 0) { // Если найден, дописать результат в найденную строку
      this.arrDecodSum[l] = ab+ar[1];
    }

    return ar[0];
  },

  renderSum(arrbase, deltax, deltay, n, g, ch){
    let errorline_sum = [], arr_sum = new Array(n);

    for (let i = 0; i < arr_sum.length; i++) { 
      let arr_line_sum = []; //сюда записываются значения элементов по столбцам
      arr_sum[i] = new Array(n);
      for (let j = 0; j < n; j++) {
        //Заполнить горизонталь
        if (j>0 && i>0) {///
          //console.log('i:', i);
          let sum = this.summ(arrbase, arrbase[i-1], arrbase[j-1], g, ch);
          arr_line_sum[j-1] = sum; //вести учет введенных элементов строки
          arr_line_sum[arrbase.length] = arrbase[i-1]; //записать номер строки, для полиномов будет [0,1,x,x+1]        
          arr_sum[i][j] = sum;
        } else {
          arr_sum[i][j] = arrbase[i-1];
        }
        //Заполнить вертикаль
        if (j==0) {
          arr_sum[0][i] = arrbase[i-1]; 
        }
      }
      // Поймать неправильный столбец в сложении, с дублями элементов 
      const duplicates_sum = arr_line_sum.filter((e, i, a) =>  
        (a.indexOf(e) !== i) && (i !== arr_line_sum.length - 1));
      if (duplicates_sum.length > 0) {  
        errorline_sum.push(arr_line_sum[arr_line_sum.length-1]);
      }
    }
    arr_sum[0][0] = '+';  

    if(this.checkedSumm) {
      let line = 1, fill = 'black';
      this.shifttablex = 0;

      this.renderLine(this.shifttablex, deltax, deltay, n); //mvv

      arr_sum.forEach((subjects) => {
        let num = 1;
        const filt = subjects.filter((e, i, a) => (a.indexOf(e) == 0) && (found(e, errorline_sum)));
        if (filt.length > 0) {
          fill = 'red';
          //this.showError('?');
        }
        let k = n;
        subjects.forEach((data) => {
          this.draw(line, num, data, deltax, deltay, fill, 20);
          num++;
          k--;
        });
        if (k==0) fill = 'black';
        line++;
      });

      this.renderArrDecodSum(n, deltay);
    }

    return errorline_sum.length;
  },

  renderArrDecodSum(n, deltay) {
    // Запомнить длину массива, нужно для сдвига расшифровки умножения
    this.lengthSumDecoding = this.arrDecodSum.length;

    const y = (deltay*n)+100;

    layer.add(this.addText(5, y, "  Суммирование:", 24));//24-размер шрифта

    for (let i = 0; i< this.arrDecodSum.length; i++) {
      if (this.arrDecodSum[i][this.arrDecodSum[i].length-1] == this.err) {
        layer.add(this.addText(20, (y+deltay)+(i*deltay), this.arrDecodSum[i], 20, 'Arial', 'red'));
      } else {
        layer.add(this.addText(20, (y+deltay)+(i*deltay), this.arrDecodSum[i], 20, 'Arial'));
      }
    }
  },

  renderParam(g){
    const gg = g > 0 ? (" Порождающий полином:  " + this.state.ggf + " = " + g) : '';
    const param = 'GF(' + this.state.qgf + ');' + gg;
    layer.add(this.addText(10, 10, param, 25));
  },

  draw(line, num, data, deltax, deltay, fill, fontSize) {
    if (data == this.err) fill = 'red';
    layer.add(this.addText(((deltax*(line-1))-(deltax/(deltax/4))+this.shifttablex+20), 
      ((deltay*num)-(deltay/(deltay/5))+50), data, fontSize, 'Arial', fill));
  },

  addLine(x1, y1, x2, y2){
    return new Konva.Line({
      x: 0,
      y: 0,
      points: [x1, y1, x2, y2],
      stroke: 'black', //red
      //tension: 1
    });
  },

  addText(x, y, txt, fontSize, fontFamily, fill) {
    return new Konva.Text({
      x: x,
      y: y,
      text: txt,
      fontSize: fontSize,
      fontFamily: fontFamily, //'Calibri' 'Georgia' 'Arial'
      fill: fill, // 'red' 'black'
    });
  },

  initFillArrDecodSum(arrbase) {
    const nol = addLeadingZero('0', arrbase[0].length);

    let arr = [...arrbase];
    arr = reduceElArrK('0', arr, 1); // удалить '0' 
    arr = reduceElArrK(nol, arr, 1); // удалить двоичные '00', '000' и т.д.

    //найти все пары элементов + сами с собой
    let arcoupl = [];
    for(let x of arr){
      for(let y of arr){
          if(x <= y){arcoupl.push([x,y])}
          else{continue}
      }
    }
    // инициировать пары и записать в arrDecodSum
    for (var i = 0; i < arcoupl.length; i++) {
      const a = arcoupl[i][0];
      const b = arcoupl[i][1];
      const start = "("+a+") + ("+b+")" + this.cursor;
      this.arrDecodSum.push(start);
    }
  },

  initFillArrDecodMult(arrbase) {
    const nol = addLeadingZero('0', arrbase[0].length);
    const one = addLeadingZero('1', arrbase[0].length);

    let arr = [...arrbase];
    arr = reduceElArrK('0', arr, 1); // удалить '0' 
    arr = reduceElArrK(nol, arr, 1); // удалить двоичные '00', '000' и т.д.

    // убрать для умножения и "1"
    arr = reduceElArrK('1', arr, 1); // удалить '1'
    arr = reduceElArrK(one, arr, 1); // удалить двоичные '01', '001' и т.д.

    //найти все пары элементов + сами с собой
    let arcoupl = [];
    for(let x of arr){
      for(let y of arr){
          if(x <= y){arcoupl.push([x,y])}
          else{continue}
      }
    }
    // инициировать пары и записать в arrDecodMult
    for (var i = 0; i < arcoupl.length; i++) {
      const a = arcoupl[i][0];
      const b = arcoupl[i][1];
      const start = "("+a+") * ("+b+")" + this.cursor;
      this.arrDecodMult.push(start);
    }
  },

  saveToPDF() {
    var canvas = document.getElementById("large-container"); //large-scroll-container
    html2canvas(canvas).then(function(canvas){
      var imgdata = canvas.toDataURL('image/png')
      var doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: [30, 20]
      });
      doc.addImage(imgdata, 'PNG', 1, 1);
      doc.save('gf.pdf');
    })
  },

  onChangePreset() {
    switch (this.preset) {
      case this.state.gf_2_2:
        this.state.qgf = '2^2';
        this.state.argf = '0,1,x,x+1';
        this.state.ggf = 'x^2+x+1';
        break;
      case this.state.gf_2_2_bin:
        this.state.qgf = '2^2';
        this.state.argf = '00,01,10,11';
        this.state.ggf = 'x^2+x+1';
        break;              
      case this.state.gf_2_3: 
        this.state.qgf = '2^3';
        this.state.argf = '0,1,x,x+1,x^2,x^2+1,x^2+x,x^2+x+1';
        this.state.ggf = 'x^3+x+1';
        break;     
      case this.state.gf_2_3_bin:
        this.state.qgf = '2^3';
        this.state.argf = '000,001,010,011,100,101,110,111';
        this.state.ggf = 'x^3+x+1';
        break; 
      case this.state.gf_2_4_bin:
        this.state.qgf = '2^4';
        this.state.argf = '0000,0001,0010,0011,0100,0101,0110,0111,1000,1001,1010,1011,1100,1101,1110,1111';
        this.state.ggf = 'x^4+x+1';
        break; 
      case this.state.gf_2_8_bin:
        this.state.qgf = '2^8';
        this.state.argf = '00000000,00000001,00000010,00000011,00000100,00000101,00000110,00000111,00001000,00001001,00001010,00001011,00001100,00001101,00001110,00001111,00010000,00010001,00010010,00010011,00010100,00010101,00010110,00010111,00011000,00011001,00011010,00011011,00011100,00011101,00011110,00011111,00100000,00100001,00100010,00100011,00100100,00100101,00100110,00100111,00101000,00101001,00101010,00101011,00101100,00101101,00101110,00101111,00110000,00110001,00110010,00110011,00110100,00110101,00110110,00110111,00111000,00111001,00111010,00111011,00111100,00111101,00111110,00111111,01000000,01000001,01000010,01000011,01000100,01000101,01000110,01000111,01001000,01001001,01001010,01001011,01001100,01001101,01001110,01001111,01010000,01010001,01010010,01010011,01010100,01010101,01010110,01010111,01011000,01011001,01011010,01011011,01011100,01011101,01011110,01011111,01100000,01100001,01100010,01100011,01100100,01100101,01100110,01100111,01101000,01101001,01101010,01101011,01101100,01101101,01101110,01101111,01110000,01110001,01110010,01110011,01110100,01110101,01110110,01110111,01111000,01111001,01111010,01111011,01111100,01111101,01111110,01111111,10000000,10000001,10000010,10000011,10000100,10000101,10000110,10000111,10001000,10001001,10001010,10001011,10001100,10001101,10001110,10001111,10010000,10010001,10010010,10010011,10010100,10010101,10010110,10010111,10011000,10011001,10011010,10011011,10011100,10011101,10011110,10011111,10100000,10100001,10100010,10100011,10100100,10100101,10100110,10100111,10101000,10101001,10101010,10101011,10101100,10101101,10101110,10101111,10110000,10110001,10110010,10110011,10110100,10110101,10110110,10110111,10111000,10111001,10111010,10111011,10111100,10111101,10111110,10111111,11000000,11000001,11000010,11000011,11000100,11000101,11000110,11000111,11001000,11001001,11001010,11001011,11001100,11001101,11001110,11001111,11010000,11010001,11010010,11010011,11010100,11010101,11010110,11010111,11011000,11011001,11011010,11011011,11011100,11011101,11011110,11011111,11100000,11100001,11100010,11100011,11100100,11100101,11100110,11100111,11101000,11101001,11101010,11101011,11101100,11101101,11101110,11101111,11110000,11110001,11110010,11110011,11110100,11110101,11110110,11110111,11111000,11111001,11111010,11111011,11111100,11111101,11111110,11111111';
        this.state.ggf = 'x^8+x^7+x^6+x+1';
        break; 
      case this.state.gf_3_1:
        this.state.qgf = '3';
        this.state.argf = '0,1,2';
        this.state.ggf = '';
        break;      
      case this.state.gf_3_2_i:
        this.state.qgf = '3^2';
        this.state.argf = '0,1,2,x,x+1,x+2,2*x,2*x+1,2*x+2';
        this.state.ggf = '';
        break;   
      case this.state.gf_3_2_k:
        this.state.qgf = '3^2';
        this.state.argf = '00,01,02,10,11,12,20,21,22';
        this.state.ggf = 'x^2+2*x+2'; //122
        break;     
      case this.state.gf_3_3_k:
        this.state.qgf = '3^3';
        this.state.argf = '000,001,002,010,011,012,020,021,022,100,101,102,110,111,112,120,121,122,200,201,202,210,211,212,220,221,222';
        this.state.ggf = 'x^3+x^2+2*x+1'; //1121
        break;
      case this.state.gf_4_1:
        this.state.qgf = '4';
        this.state.argf = '0,1,2,3';
        this.state.ggf = '';
        break;
      case this.state.gf_5_1:
        this.state.qgf = '5';
        this.state.argf = '0,1,2,3,4';
        this.state.ggf = '';
        break;      
      case this.state.gf_5_1_bin:
        this.state.qgf = '5';
        this.state.argf = '000,001,010,011,100';
        this.state.ggf = '';
        break; 
      case this.state.gf_5_2_k:
        this.state.qgf = '5^2';
        this.state.argf = '00,01,02,03,04,10,11,12,13,14,20,21,22,23,24,30,31,32,33,34,40,41,42,43,44';
        this.state.ggf = 'x^2+x+2';
        break;           
      case this.state.gf_6_1:
        this.state.qgf = '6';
        this.state.argf = '0,1,2,3,4,5';
        this.state.ggf = '';
        break; 
      case this.state.gf_7_1:
        this.state.qgf = '7';
        this.state.argf = '0,1,2,3,4,5,6';
        this.state.ggf = '';
        break;  
      case this.state.gf_7_1_bin:
        this.state.qgf = '7';
        this.state.argf = '000,001,010,011,100,101,110';
        this.state.ggf = '';
        break;       
      case this.state.gf_8_1_bin:
        this.state.qgf = '8';
        this.state.argf = '000,001,010,011,100,101,110,111';
        this.state.ggf = '';
        break;   
    }

    this.gencheck();
  },

  generatevalid() {
    if (!this.v$.$invalid ) {
      this.gencheck();
    }
  },

  gencheck(){
    // обнулить данные:
    layer.removeChildren();
    this.lengthSumDecoding = 0;
    this.shifttablex = 0;
    this.deltashifttablex = 17;
    this.shownError = false;

    const arrbase = this.state.argf.split(',');
    this.defineMode(arrbase);

    let check = false;
    check = this.checkDegree();
    check = this.checkSet(arrbase);

    if(check) this.gentable(arrbase);
  },

  checkSet(arrbase){ //mvv проверка множества на шаг = 1
    let r = true, arr=[], p=1;
  
    if(this.state.qgf.includes('^')) {
      const arqgf= this.state.qgf.split('^');
      p = Number(arqgf[0]); 
    } else {
      p = Number(this.state.qgf);
    }

    const g = polinomKtoBin(this.state.ggf);

    // проверять для всех mod'ов
    if (this.state.mode==0) { //Полиномиальный
      for (let i = 0; i < arrbase.length; i++) {
        arr.push(polinomToDec(arrbase[i]).toString()); //полином в 10-ю систему
      }
    } else if (this.state.mode==1) { //Числовой
      arr = [...arrbase];
    } else if (this.state.mode==2) { //Двоичный
      let char = 2;
      if(checkBik(g)) char = Number(p);
      for (let i = 0; i < arrbase.length; i++) {
        arr.push(parseInt(arrbase[i], char).toString()); //в 10-ю систему 
      }
    }

    for (let i = 0; i < arr.length; i++) {
      if (i>0) {
        r = this.checkSetPair(arr[i-1], arr[i]);
        if(!r) break;
      }
    }

    if(!r) {
      this.dialog_title = 'Ошибка';
      this.dialog_text = 'Шаг множества не соблюден';
      this.dialog = true;
    }

    return r;
  },

  checkSetPair(a, b){ // разница между a и b должно быть 1
    if(( Number(b) - Number(a)) == 1 ) {
      return true;
    } else {
      return false;
    }
  },

  checkDegree(){
    //проверка что степени равны в '3^3' и 'x^3+2*x+2'
    let r = true;

    if(this.state.ggf) {
      let n1=1, n2=1;
      if(this.state.qgf.includes('^')) {
        const arq= this.state.qgf.split('^');
        n1 = Number(arq[1]);
      }

      const argf = this.state.ggf.split('+');
      if(argf[0].includes('^')) {
        const arg = argf[0].split('^');
        n2 = Number(arg[1]);
      }
      r = (n1 === n2);
    }
    
    if(!r) {
      this.dialog_title = 'Ошибка';
      this.dialog_text = 'Степени порядка GF и первого члена порождающего полинома не равны';
      this.dialog = true;
    }

    return r;
  },

//#endregion

},

computed: {
  ...mapGetters(["gen"]),
},

setup () {
  const numregex= helpers.regex(/^(\d*\^\d*|\d)*$/)
  const state = reactive({ 
    qgf:  '', argf: '', ggf:  '', mode:  '',
    gf_2_2: 'GF(2^2)',
    gf_2_2_bin: 'GF(2^2)bin',
    gf_2_3: 'GF(2^3)',
    gf_2_3_bin: 'GF(2^3)bin',
    gf_2_4_bin: 'GF(2^4)bin',
    gf_2_8_bin: 'GF(2^8)bin',
    gf_3_1: 'GF(3)',
    gf_3_2_i: 'GF(3^2)i',
    gf_3_2_k: 'GF(3^2)k',
    gf_5_2_k: 'GF(5^2)k',
    gf_3_3_k: 'GF(3^3)k',
    gf_4_1: 'GF(4)',
    gf_5_1: 'GF(5)',
    gf_6_1: 'GF(6)',
    gf_5_1_bin: 'GF(5)bin',
    gf_7_1: 'GF(7)',
    gf_7_1_bin: 'GF(7)bin',
    gf_8_1_bin: 'GF(8)bin',
    stMult: 'Умножение',
    stSumm: 'Суммирование',
    stDegree: 'Таблица cтепеней',
    stReport: 'Короткий отчет',
  })
  const rules = {
    qgf: { required, numregex: helpers.withMessage('число^число или число', numregex) },    argf: { required },
  }
  const v$ = useVuelidate(rules, state)
  return { state, v$ }
},

};
</script>
